import React, { Component } from 'react'
import PropTypes from 'prop-types'
import injectSheet from 'react-jss'
import classNames from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const styles = () => {
  return {
    container: {
      width: '100%',
      position: 'relative',
    },
    itemsContainer: {
      backgroundColor: 'white',
      borderRadius: '20px',
      border: '1px solid #D2D2D2',
      paddingTop: '10px',
      paddingBottom: '10px',
      textAlign: 'left',
      cursor: 'pointer',
      listStyle: 'none',
      padding: 0,
      maxHeight: '40vh',
      overflowX: 'hidden',
      overflowY: 'scroll',
      position: 'absolute',
      top: '25px',
      left: 0,
      right: 0,
      zIndex: 1000,
    },
    itemsContainerListItem: {
      paddingLeft: '5px',
      paddingRight: '5px',
      marginLeft: '10px',
      marginRight: '10px',
      borderBottom: 'solid 1px #D2D2D2',
    },
    itemButton: {
      paddingTop: '8px',
      paddingLeft: '4px',
      paddingBottom: '8px',
      border: 0,
      outline: 0,
      width: '100%',
      textAlign: 'left',
      cursor: 'pointer',
      fontSize: '14px',
      borderRadius: '20px',
      '&:hover': {
        backgroundColor: '#D2D2D2',
      },
      display: 'flex',
      alignItems: 'center',
    },
    itemIcon: {
      width: '28px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    itemIconImage: {
      objectFit: 'contain',
      height: '16px',
      width: '16px',
    },
    selectButton: {
      backgroundColor: 'white',
      borderRadius: '50px',
      height: '40px',
      boxShadow: '0 3px 3px #D2D2D2',
      border: 0,
      outline: 0,
      width: '100%',
      paddingTop: '10px',
      paddingLeft: '20px',
      paddingBottom: '10px',
      paddingRight: '36px',
      textAlign: 'left',
      cursor: 'pointer',
      fontSize: '14px',
      display: 'flex',
      alignItems: 'center',
    },
    selectButtonOpen: {
      boxShadow: 'inset 0 3px 5px rgba(0, 0, 0, 0.125)',
    },
    selectDropDownCaret: {
      top: '10px',
      right: '20px',
      position: 'absolute',
    },
  }
}

@injectSheet(styles)
class DropDownSelect extends Component {
  state = {
    isOpen: false,
    selectedIndex: 0,
    disable: false,
  }

  constructor(props) {
    super(props)
    const { selectedIndex = 0, disable = false } = props
    this.state.selectedIndex = selectedIndex
    this.state.disable = disable
  }

  static defaultProps = {
    items: [],
    selectedIndex: 0,
  }

  componentDidMount() {
    const { items } = this.props
    const { selectedIndex } = this.state
    if (selectedIndex < items.length) {
      this.handleSelectItem(items[selectedIndex].value, selectedIndex)
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.selectedIndex !== this.props.selectedIndex) {
      this.setState({ selectedIndex: this.props.selectedIndex })
    }
  }

  handleSelectButtonClick = () => {
    const { isOpen, disable } = this.state
    if (!disable) {
      this.setState({
        isOpen: !isOpen,
      })
    }
  }

  handleSelectItem = (value, index) => {
    const { onItemChange } = this.props
    if (onItemChange) {
      onItemChange(value, index)
    }
    this.setState({
      isOpen: false,
      selectedIndex: index,
    })
  }

  render() {
    const { classes, items } = this.props
    const { isOpen, selectedIndex } = this.state
    return (
      <div className={classes.container}>
        <button
          className={classNames(classes.selectButton, {
            [classes.selectButtonOpen]: isOpen,
          })}
          onClick={this.handleSelectButtonClick}
        >
          <div className={classes.itemIcon}>
            {items[selectedIndex].icon && (
              <span>
                <FontAwesomeIcon
                  icon={items[selectedIndex].icon}
                  color={items[selectedIndex].iconColor && items[selectedIndex].iconColor}
                  size="lg"
                  fixedWidth
                />
              </span>
            )}
            {items[selectedIndex].png && (
              <img className={classes.itemIconImage} src={items[selectedIndex].png} alt="" />
            )}
          </div>
          <div style={{ marginLeft: '4px' }}>
            {items.length > 0 && items[selectedIndex] && items[selectedIndex].name}
          </div>
        </button>
        {isOpen && (
          <ul className={classes.itemsContainer}>
            {items.map((item, index) => {
              return (
                <li
                  className={classes.itemsContainerListItem}
                  key={item.value}
                  onClick={() => {
                    return this.handleSelectItem(item.value, index)
                  }}
                >
                  <div className={classes.itemButton}>
                    <div className={classes.itemIcon}>
                      {item.icon && (
                        <span>
                          <FontAwesomeIcon
                            icon={item.icon}
                            color={item.iconColor && item.iconColor}
                            size="lg"
                            fixedWidth
                          />
                        </span>
                      )}
                      {item.png && <img className={classes.itemIconImage} src={item.png} alt="" />}
                    </div>
                    <div style={{ marginLeft: '4px' }}>{item.name}</div>
                  </div>
                </li>
              )
            })}
          </ul>
        )}
        <div className={classes.selectDropDownCaret}>
          <FontAwesomeIcon icon={'caret-down'} />
        </div>
      </div>
    )
  }
}

DropDownSelect.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired]),
      name: PropTypes.string.isRequired,
    }),
  ).isRequired,
  selectedIndex: PropTypes.number,
  disable: PropTypes.bool,
  classes: PropTypes.object,
  onItemChange: PropTypes.func,
}

export default DropDownSelect
